module.exports = __webpack_public_path__ + "img/img3.7ba53e57.png";